import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';


function ClientDropdown({ onChangeDropdown, modelName, required, selectedValue, isDisable }) {
  const [selectedClientOption, setSelectedClientOption] = useState(null);
  const [getClientOptions, setClientOptions] = useState([]);
    const [ClientChanged, setClientChanged] = useState(false);

    function handleChange(e, actionMeta) {
        setSelectedClientOption(e);
        setClientChanged(true);
        onChangeDropdown(e, actionMeta);
    };
    
    function setClientDropdownData(cct) {
      const source = Array.isArray(cct) ? cct : [];
      let allClientOpt = [];
      allClientOpt = source.map(p => ({ value: p.ClientId, label: p.ClientName, name: p.ClientName, description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setClientOptions(allClientOpt);
      setSelectedClientOption(allClientOpt.find(x => x.value === selectedValue) || null);
    }

    useEffect(() => {
        const fetchClients = async () => {
            try {
              let dropdownDetails = {
                UserId: localStorage.getItem('userId'),
                IsForDropodown: 1
              };
              const response = await axios.get(getApiBaseUrl() + "/familyHeadfdd", {
                params: dropdownDetails
              });
              if (response.status === 200) {
                setClientDropdownData(response?.data?.data?.[0] || []);
              }
            } catch (error) {
              console.log(error);
            }
        };
        fetchClients();
    }, []);
    return (
        <div className="col-12">
            <div className="mb-3">
                <label className="form-label">
                    Client { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                </label>
                <Select
                    name={modelName}
                  value={selectedClientOption}
                    isClearable={true}
                  options={Array.isArray(getClientOptions) ? getClientOptions : []}
                    onChange={handleChange}
                    isDisabled = {isDisable}
                />
            </div>
        </div>
    )
}

export default ClientDropdown